import { combineReducers, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isNumber } from "lodash";
import { axiosDelete, axiosGet, axiosPut } from "utils/APIHelper";
import { responseTypes, serviceTypes } from "utils/Types";
import { NotificationState } from "./Notifications";

const initialState: NotificationState = {
  list: [],
  unreadNotifications: 0,
  notifiedByList: [],
  isLoading: false
};

export const fetchUsersAsync = createAsyncThunk(`getUsers`, async (data: any, thunkApi) => {
  const API_URL = `associates?hltIds=${data}`;
  const response: any = await axiosGet(API_URL, "user");
  return response.data;
});

export const getNotifications = createAsyncThunk(`getNotifications`, async (data: any, thunkApi: any) => {
  const { rejectWithValue } = thunkApi;
  const API_URL = "notifications";
  const response: any = await axiosGet(API_URL, serviceTypes.notification, data);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  return response.data;
});

export const putNotifications = createAsyncThunk(`putNotifications`, async (data: any, thunkApi: any) => {
  const { rejectWithValue } = thunkApi;
  const API_URL = "notifications";
  const response: any = await axiosPut(API_URL, serviceTypes.notification, data);
  if (response.status !== responseTypes.success) {
    return rejectWithValue(response.response.data);
  }
  return response.data;
});

export const deleteNotifications = createAsyncThunk(`deleteNotifications`, async (data: any, thunkApi) => {
  const { fulfillWithValue, rejectWithValue } = thunkApi;
  const API_URL = `notifications?notificationIds=${data.id}`;
  const response = await axiosDelete(API_URL, serviceTypes.notification);
  if (response.status === responseTypes.no_content) {
    return fulfillWithValue(data);
  } else {
    return rejectWithValue(response.response.data);
  }
});

export const NotificationsSlice = createSlice({
  name: "Notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotifications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotifications.fulfilled, (state, action: any) => {
        state.list = action.payload.notifications;
        state.unreadNotifications = action.payload.notifications.filter((item: any) => item.isRead === "N").length;
        if (!action.payload.notifications.length) {
          state.isLoading = false;
        }
      })
      .addCase(fetchUsersAsync.fulfilled, (state, action: any) => {
        state.notifiedByList = action.payload.users;
        state.isLoading = false;
      })
      .addCase(getNotifications.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(putNotifications.fulfilled, (state, action: any) => {
        state.list = action.payload.notifications;
        state.unreadNotifications = action.payload.notifications.filter((item: any) => item.isRead === "N").length;
      })
      .addCase(deleteNotifications.fulfilled, (state, action: any) => {
        if (!isNumber(action.payload.id)) {
          state.list = [];
          state.unreadNotifications = 0;
        } else {
          state.list = state.list.filter((item: any) => item.id !== action.payload.id);
          state.unreadNotifications = state.list.filter((item: any) => item.isRead === "N").length;
        }
      });
  }
});

const rootReducer = combineReducers({
  data: NotificationsSlice.reducer
});

export default rootReducer;
